import Grid from '@zenbusiness/zui/Grid';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import FieldDetail from '../FieldDetail';

export default function CardDetail({ cardHolder, type, cardNumber, loading }) {
  return (
    <Grid
      columnSpacing="8px"
      container
      pb={{ xs: '24px', lg: '56px' }}
      pt={{ xs: '24px', lg: '32px' }}
      px={{ xs: '24px', lg: '32px' }}
      rowSpacing={{ xs: '16px', lg: '32px' }}
    >
      <Grid
        item
        xs={12}
      >
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          <Text
            color="primary"
            size="xl"
            weight="medium"
          >
            Sender
          </Text>
        </Stack>
      </Grid>
      <FieldDetail
        label="Cardholder name"
        loading={loading}
        value={cardHolder}
      />
      <FieldDetail
        label="Card type"
        loading={loading}
        value={type}
      />
      <FieldDetail
        label="Card number"
        loading={loading}
        value={cardNumber}
      />
    </Grid>
  );
}

CardDetail.propTypes = {
  cardHolder: PropTypes.string,
  type: PropTypes.string,
  cardNumber: PropTypes.string,
  loading: PropTypes.bool
};
